import { render, staticRenderFns } from "./WorkShopEdit.vue?vue&type=template&id=4148b896&"
import script from "./WorkShopEdit.vue?vue&type=script&lang=js&"
export * from "./WorkShopEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports